import { Trans } from 'react-i18next';
import { classes } from '../../../utils/commonUtils';
import styles from './search-results.module.scss';

interface NoResultsPlacementProps {
  query: string;
}

const NoResultsPlacement = ({ query }: NoResultsPlacementProps) => {
  function noResultsText() {
    if (query.length === 0) {
      return <Trans i18nKey="write something in the search field" />;
    }

    return <Trans i18nKey="no results general" values={{ query }} />;
  }

  return (
    <div className={styles.no_results} key={'no-results'}>
      <span className={classes(styles.searchIcon, 'aib-icon')}>E</span>
      <div className={styles.text}>{noResultsText()}</div>
    </div>
  );
};

export default NoResultsPlacement;
